import React from 'react';

interface MilestoneProgressOverviewProps {
  completedCount: number;
  totalCount: number;
  className?: string;
}

const MilestoneProgressOverview: React.FC<MilestoneProgressOverviewProps> = ({
  completedCount,
  totalCount,
  className = '',
}) => {
  const progressPercentage = totalCount > 0 ? (completedCount / totalCount) * 100 : 0;

  return (
    <div className={`bg-white border rounded-lg p-4 ${className}`}>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-medium text-gray-700">Overall Progress</h3>
        <span className="text-sm font-semibold text-gray-900">
          {completedCount} / {totalCount} completed
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-3">
        <div
          className="bg-green-500 h-3 rounded-full transition-all duration-300"
          style={{ width: `${progressPercentage}%` }}
          role="progressbar"
          aria-valuenow={progressPercentage}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
      <p className="text-xs text-gray-500 mt-1">{Math.round(progressPercentage)}% complete</p>
    </div>
  );
};

export default MilestoneProgressOverview;

